var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"w-11/12 px-6 my-2 -ml-4 bg-blue-100 border-l-4 border-blue-500 md:w-5/5 rounded-r-md"},[_c('div',{staticClass:"flex items-center py-4"},[_c('div',{staticClass:"ml-5"},[_c('h1',{staticClass:"text-lg font-bold"},[_vm._v("Message de Succès")]),_vm._t("default")],2)])])
}
var staticRenderFns = []

export { render, staticRenderFns }